document.querySelectorAll('table').forEach((tbl) => {
  const wrapper = document.createElement('div');

  wrapper.style.wordBreak = 'keep-all';
  wrapper.className = 'table-responsive';
  tbl.parentNode.replaceChild(wrapper, tbl);
  wrapper.appendChild(tbl);
});
